<template>
    <div
        :class="['caja-container', { 'vista-detalle': vistaDetalle }, { 'vista-mapa': vistaMapa }, { 'vista-cuadricula': vistaCuadricula }]">
        <div :class="['estado-color', `estado-${oscilo.IdOsciloEstadoTipo}`]">

        </div>
        <div class="informacion-oscilo">
            <div class="datos-header">
                <div class="informacion-oscilo-container">
                    <div v-if="vistaCuadricula || vistaDetalle">
                        <label class="nombre-instalacion">{{ oscilo.NombreCompletoInstalacion }}</label>
                    </div>

                    <div v-if="vistaMapa || vistaCuadricula || vistaDetalle">
                        <label class="nombre-oscilo">{{ oscilo.Nombre }}</label>
                    </div>

                    <div v-if="vistaMapa || vistaCuadricula || vistaDetalle">
                        <label :class="['estado-texto', `estado-${oscilo.IdOsciloEstadoTipo}`]">
                            <i :class="obtenerClaseOsciloEstadoTipo(oscilo.IdOsciloEstadoTipo)"
                                class="estado-icono"></i>
                            {{ getNombreOsciloEstadoTipo(oscilo.IdOsciloEstadoTipo) }}
                        </label>

                    </div>
                </div>
                <div>
                    <DxButton v-bind="updateButtonProps()" icon="fa-solid fa-arrow-down-arrow-up"
                        :hint="$t('oscilos.cajita_oscilos.encolar_peticion_manual_descarga')"
                        @click="encolarPeticionManualDescarga(oscilo)"
                        v-if="((vistaMapa || vistaCuadricula || vistaDetalle) && tienePermisoOscilosEncolarPeticionManualDescarga(autho))">
                    </DxButton>
                </div>
            </div>
            <div class="datos-oscilo-detalle">
                <div :class="['datos-oscilo', { 'vista-detalle': vistaDetalle }]">
                    <div v-if="vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.numero_serie') }} </label>
                        <span>{{ oscilo.NumeroSerie }}</span>
                    </div>

                    <div v-if="vistaCuadricula || vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.ip_publica') }}</label>
                        <span>{{ oscilo.IpPublica }} : {{ (oscilo as any).PuertoFtp }} </span>
                    </div>

                    <div v-if="vistaMapa || vistaCuadricula || vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.fecha_ultimo_intento_descarga') }} </label>
                        <span>{{ fechaUltimoIntentoDescargaString }}</span>
                    </div>

                    <div v-if="vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.nombre_empresa_instalacion') }} </label>
                        <span>{{ oscilo.NombreEmpresaInstalacion }}</span>
                    </div>

                    <div v-if="vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.nombre_jefe_zona') }} </label>
                        <span>{{ oscilo.NombreJefeZona }}</span>
                    </div>

                    <div v-if="vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.telefono_jefe_zona') }} </label>
                        <span>{{ oscilo.TelefonoJefeZona }}</span>
                    </div>

                    <div v-if="vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.email_jefe_zona') }} </label>
                        <span>{{ oscilo.EmailJefeZona }}</span>
                    </div>

                    <div v-if="vistaDetalle" class="campo-datos">
                        <label>{{ $t('oscilos.cajita_oscilos.fecha_instalacion') }} </label>
                        <span>{{ fechaInstalacionString }}</span>
                    </div>
                </div>

                <div class="mapa-miniatura"
                    v-if="(((vistaCuadricula) || (vistaDetalle)) && ((oscilo.LatitudInstalacion != null) && (oscilo.LongitudInstalacion != null)))">
                    <l-map :zoom="7" :center="[oscilo.LatitudInstalacion, oscilo.LongitudInstalacion]"
                        style="height: 100%; width: 200px; border-radius: 16px;min-height: 120px;"
                        :use-global-leaflet="false">
                        <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base"
                            name="OpenStreetMap"></l-tile-layer>
                        <l-marker :lat-lng="[oscilo.LatitudInstalacion, oscilo.LongitudInstalacion]"
                            :icon="getMarkerIcon(oscilo.IdOsciloEstadoTipo as OsciloEstadoTipoEnum)">
                        </l-marker>
                    </l-map>
                </div>
            </div>
        </div>

        <div v-if="vistaMapa || vistaCuadricula">
            <DxButton v-bind="masInformacionButtonProps()" @click="masInformacion(oscilo)">
            </DxButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, } from 'vue';
import { useIntl } from '@services/i18n'
import { DxButton } from 'devextreme-vue';
import { useApi } from '@/.shared/.api/integration';
import { OsciloEstadoTipoEnum } from '@/model/oscilo';
import type { OsciloDetalleModel } from '@/.shared/.api';
import { getMarkerIcon } from '@/.shared/helpers/map-helper';
import { useRouter } from '@/.shared/services/routing-services';
import { standardFormatDate } from '@/.shared/helpers/date-helper';
import { useAuthorization } from '@/.shared/services/auth/authorization';
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet';
import { toastSuccess, toastError } from '@/.shared/services/notification-service';
import { updateButtonProps, masInformacionButtonProps } from '@helpers/button-helper';
import { tienePermisoOscilosEncolarPeticionManualDescarga } from '@/.shared/helpers/permission-helper';
import { getNombreOsciloEstadoTipo } from '@/.shared/helpers/oscilo-estado-tipo-helper';
const props = defineProps<{ osciloProp: OsciloDetalleModel, vistaMapaProp: boolean, vistaCuadriculaProp: boolean, vistaDetalleProp: boolean }>();
const oscilo = computed(() => props.osciloProp);

const vistaMapa = props.vistaMapaProp;
const vistaCuadricula = props.vistaCuadriculaProp;
const vistaDetalle = props.vistaDetalleProp;

const api = useApi();
const intl = useIntl();
const router = useRouter();
const autho = useAuthorization();

const fechaInstalacionString = computed(() => {
    const fechaInstalacion = oscilo.value.FechaInstalacion;
    const codigoZonaHorariaInstalacion = oscilo.value.CodigoZonaHorariaInstalacion;
    return standardFormatDate(fechaInstalacion, codigoZonaHorariaInstalacion);
});

const fechaUltimoIntentoDescargaString = computed(() => {
    const fechaUltimoIntentoDescarga = oscilo.value.FechaUltimoIntentoDescarga;
    const codigoZonaHorariaInstalacion = oscilo.value.CodigoZonaHorariaInstalacion;
    return standardFormatDate(fechaUltimoIntentoDescarga, codigoZonaHorariaInstalacion);
});

async function encolarPeticionManualDescarga(oscilo: OsciloDetalleModel): Promise<void> {
    const idPeticionManualDescarga = await api.callStandardApi("osciloEncolarPeticionManualDescarga", { showLoading: false }, oscilo.Id);
    if (idPeticionManualDescarga > 0)
        toastSuccess(intl.i18n.t('oscilos.popup_cajita_oscilo.mensaje_encolar_peticion_manual_exito'));
    else
        toastError(intl.i18n.t('oscilos.popup_cajita_oscilo.mensaje_encolar_peticion_manual_error'));
}

async function masInformacion(oscilo: OsciloDetalleModel): Promise<void> {
    router.push(intl.i18Route({ name: "oscilo-detalle-view", params: { id: oscilo.Id } }));
}

function obtenerClaseOsciloEstadoTipo(idOsciloEstadoTipo: number): string {
    switch (idOsciloEstadoTipo) {
        case OsciloEstadoTipoEnum.NoInicializado:
            return "fa-regular fa-square-dashed";
        case OsciloEstadoTipoEnum.Funcionando:
            return "fa-regular fa-circle-check";
        case OsciloEstadoTipoEnum.Standby:
            return "fa-regular fa-circle-pause";
        case OsciloEstadoTipoEnum.SucesoNuevo:
            return "fa-regular fa-triangle-exclamation";
        case OsciloEstadoTipoEnum.SucesoReciente:
            return "fa-regular fa-circle-exclamation";
        case OsciloEstadoTipoEnum.SucesoAntiguo:
            return "fa-regular fa-circle-exclamation";
        case OsciloEstadoTipoEnum.Error:
            return "fa-regular fa-triangle-exclamation";
        default:
            return "";
    }
}
</script>



<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";


.caja-container {
    display: flex;
    position: relative;
    overflow: hidden;
    padding: var(--spacing-md);
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-xs);
    flex: 1 0 0;
    border-radius: var(--ui-oscilo-card-radius);
    background: var(--background-default-default);
    box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);
}

.caja-container.vista-mapa {
    padding: var(--spacing-sm);
    margin-bottom: var(--spacing-sm);
}

.datos-header {
    border-bottom: var(--border-widht-sm) solid var(--border-default-default);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    padding: var(--spacing-xs) 0px;

}

.datos-oscilo {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
}

.datos-oscilo.vista-detalle {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: var(--spacing-xs);
    grid-auto-rows: max-content;
    width: 100%;
}

.informacion-oscilo {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    align-self: stretch;
}

.datos-oscilo-detalle {
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex: 1 0 0;
    justify-content: space-between;
}

.nombre-instalacion {
    color: $base-accent;
    font-weight: 600;
    line-height: var(--line-height-body-md);

}

.nombre-oscilo {
    font-weight: 600;
    line-height: var(--line-height-body-md);
}

.vista-mapa .nombre-oscilo {
    color: $base-accent
}

.mapa-miniatura {
    overflow: auto;
    display: flex;
    min-width: 200px;
}

.estado-color[class^="estado-"] {
    width: 100%;
    height: var(--ui-oscilo-card-estado-color-height);
    position: absolute;
    top: 0;
}

//No inicializado
.estado-color.estado-0 {
    background: var(--background-ui-estado-no-inicializado);
}

//Funcionando
.estado-color.estado-1 {
    background: var(--background-ui-estado-funcionando);
}

//Stand by
.estado-color.estado-2 {
    background: var(--background-ui-estado-standby);
}

//Suceso nuevo
.estado-color.estado-3 {
    background: var(--background-ui-estado-suceso-nuevo);
}

//Suceso reciente
.estado-color.estado-4 {
    background: var(--background-ui-estado-suceso-reciente);
}

//Suceso antiguo
.estado-color.estado-5 {
    background: var(--background-ui-estado-suceso-antiguo);
}

//Error
.estado-color.estado-6 {
    background: var(--background-ui-estado-error);
}

.estado-texto[class^="estado-"] {
    font-weight: 600;
}

//No inicializado
.estado-texto.estado-0 {
    color: var(--text-ui-estado-no-inicializado);
}

//Activo
.estado-texto.estado-1 {
    color: var(--text-ui-estado-funcionando);
}

//Stand by
.estado-texto.estado-2 {
    color: var(--text-ui-estado-standby);
}

//Suceso nuevo
.estado-texto.estado-3 {
    color: var(--text-ui-estado-suceso-nuevo);
}

//Suceso reciente
.estado-texto.estado-4 {
    color: var(--text-ui-estado-suceso-reciente);
}


//Suceso grave
.estado-texto.estado-5 {
    color: var(--text-ui-estado-suceso-antiguo);
}

//Sin cobertura
.estado-texto.estado-6 {
    color: var(--text-ui-estado-error);
}

.campo-datos label,
.campo-datos span {
    display: block;
    line-height: var(--line-height-body-md);
}

@media (max-width: 991px) {
    .mapa-miniatura {
        display: none;
    }
}
</style>